import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';
import { useLocation } from 'react-router-dom';

import { convertPathnameToPattern } from './useMetricsLogger';

export function useNotFoundLogger(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    datadogLogs.logger.info('NotFound', {
      route: {
        pathname: convertPathnameToPattern(pathname),
      },
    });
  }, [pathname]);
}
